import React from 'react';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import Card from 'react-bootstrap/Card'
import i5 from './asset/i5.jpg'



const About = () => {

    return (
        <div className="card border-0 shadow my-5">
                <div className="card-body p-5">
        <div className="about">
            <div className="col-13" style={{backgroundColor:"white",padding:20}}>
            
            <Card style={{ width: '100' }}>
                <Card.Img variant="top" src={i5} />
                <Card.Body>
                    <Card.Title><h1>Game Dikha..</h1></Card.Title>
                    <Card.Text>
                    Time for Hosting Event Company (THE) provides strategic  event planning and creative delivery of sport events for a variety of industries  including, technology, non-profit, athletic and more. We are industry leading service provider in field of Cricket
We help you meet all your sport events need and creative production management. We offer strategic guidance and program management, from concept to delivery to analysis.

Whether your event is a corporate event, grand opening, recognition event or new game concept you can trust our professional planners to make your special event a memorable success through our exceptional event planning services in Gurgaon,Noida,Delhi NCR ,many more cities coming soon.

Game Dikha, is a concept for cricket players ranking. It has leaderboard and point based system that ranks them among their competitors  .This is our one of special product empowering and reinforcing the budding talent by providing them the appropriate platform and community. This doesn't ends up here winners are rewarded for it. So,the game pays you with exciting prizes

In addition, THE is committed to Perfection and supplying awesome services with diversity of products.
                   
                   
                    </Card.Text>
                    
                </Card.Body>
                </Card>
                
              
            </div>
        </div>
        </div>
        </div>

    );

}

export { About };
